import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faBook, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { TranslateFunction } from 'react-localize-redux';
import { PageType, TranslateType } from 'typings';

type Images =
  | 'tokens-white'
  | 'tokens-grey'
  | 'thinking-white'
  | 'thinking-grey'
  | '404'
  | 'world'
  | 'tokens-grey-plus'
  | 'physical-process-scan';

type ReturnType = {
  img: Images;
  title: TranslateType | undefined;
  description: TranslateType | undefined;
  conditions?: 'teacher'[];
  buttons?: {
    name: TranslateType | undefined;
    to: string;
    icon?: any;
    conditions?: ('query' | 'teacher' | 'scan')[];
  }[];
};

export function getNoContentItems(
  page: PageType,
  translate: TranslateFunction
  // @ts-ignore
): ReturnType {
  if (page === 'buildingblocks')
    return {
      img: 'tokens-grey',
      title: translate('nocontent.buildingblocks.title'),
      description: '',
    };
  if (page === 'projects')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.projects.title'),
      description: translate('nocontent.projects.description'),
    };
  if (page === 'courses')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.courses.title'),
      description: translate('nocontent.courses.description'),
    };
  if (page === 'my-reflections')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-reflections.title'),
      description: translate('nocontent.my-reflections.description'),
      buttons: [
        {
          name: translate('project.actions.create-project'),
          to: '/werkplaats/thema-bouwer',
          icon: faPlus,
          conditions: ['query'],
        },
        {
          name: translate('general.terms.watch-groowtorial'),
          to: '/bibliotheek/groowtorials',
          icon: faUsers,
        },
      ],
    };
  if (page === 'judge')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.judge.title'),
      description: translate('nocontent.judge.description'),
      buttons: [
        {
          name: translate('general.terms.my-projects'),
          to: '/werkplaats/mijn-projecten',
          icon: faBook,
          conditions: ['query'],
        },
        {
          name: translate('general.terms.watch-groowtorial'),
          to: '/bibliotheek/groowtorials',
          icon: faUsers,
        },
      ],
    };
  if (page === 'assessments')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-assessments.title'),
      // @ToDo: Translate
      description: translate('nocontent.my-assessments.description'),
      buttons: [
        {
          name: translate('reflection.terms.my-reflections'),
          to: '/werkplaats/mijn-reflecties',
          // icon: faBook,
          conditions: ['query'],
        },
      ],
    };
  if (page === 'assessments-extern')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-assessments.title'),
      // @ToDo: Translate
      description: translate('nocontent.my-assessments.description-extern'),
      buttons: [
        {
          name: translate('general.terms.my-projects'),
          to: '/werkplaats/mijn-projecten',
          // icon: faBook,
          conditions: ['query'],
        },
      ],
    };
  if (page === 'assessments-teacher')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-assessments.title'),
      // @ToDo: Translate
      description: translate('nocontent.my-assessments.description-extern'),
      buttons: [
        {
          name: translate('general.terms.feedback'),
          to: '/groei/feedback-geven',
          // icon: faBook,
          conditions: ['query'],
        },
      ],
    };
  if (page === 'my-projects')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-projects.title'),
      description: translate('nocontent.my-projects.description'),
      buttons: [
        {
          name: translate('project.actions.create-project'),
          to: '/werkplaats/thema-bouwer',
          icon: faPlus,
          conditions: ['query'],
        },
        {
          name: translate('general.terms.watch-groowtorial'),
          to: '/bibliotheek/groowtorials',
          icon: faUsers,
        },
      ],
    };
  if (page === 'my-courses')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-courses.title'),
      description: translate('nocontent.my-courses.description'),
      buttons: [
        {
          name: translate('course.actions.create-course'),
          to: '/werkplaats/training-bouwer',
          icon: faPlus,
          conditions: ['query', 'teacher'],
        },
        {
          name: translate('general.terms.watch-groowtorial'),
          to: '/bibliotheek/groowtorials',
          icon: faUsers,
        },
      ],
    };
  if (page === 'my-messages')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-messages.title'),
      description: translate('nocontent.my-messages.description'),
    };
  if (page === 'my-portfolios')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-portfolios.title'),
      description: translate('nocontent.my-portfolios.description'),
      buttons: [
        {
          name: translate('portfolio.actions.to-my-work'),
          to: '/show/mijn-werk',
          icon: faBook,
        },
      ],
    };
  if (page === 'portfolio-content')
    return {
      img: 'thinking-grey',
      title: translate('portfolio.errors.empty-portfolio'),
      description: translate('portfolio.errors.empty-portfolio-description'),
      buttons: [
        {
          name: translate('portfolio.actions.to-my-work'),
          to: '/show/mijn-werk',
          icon: faBook,
        },
      ],
    };
  if (page === 'my-work')
    return {
      img: 'thinking-grey',
      title: translate('nocontent.my-work.title'),
      description: translate('nocontent.my-work.description'),
      buttons: [
        {
          name: translate('portfolio.actions.to-my-projects'),
          to: '/werkplaats/mijn-projecten',
        },
        {
          name: translate('portfolio.actions.to-my-courses'),
          to: '/werkplaats/mijn-trainingen',
        },
      ],
    };
  if (page === 'project')
    return {
      img: 'tokens-grey-plus',
      title: translate('nocontent.project.title'),
      description: translate('nocontent.project.description'),
      buttons: [
        {
          name: translate('project.actions.add-scan-photo'),
          to: '',
          conditions: ['scan'],
          icon: '/images/beta-white.svg',
        },
        {
          name: translate('project.actions.add-process'),
          to: '',
          conditions: ['query'],
        },
      ],
    };
  if (page === 'project-scan')
    return {
      img: 'physical-process-scan',
      title: translate('nocontent.project-scan.title'),
      description: translate('nocontent.project-scan.description'),
      buttons: [
        {
          name: translate('project.actions.add-scan-photo'),
          to: '',
          conditions: ['scan'],
        },
      ],
    };
  if (page === 'training')
    return {
      img: 'tokens-grey',
      title: translate('nocontent.training.title'),
      description: translate('nocontent.training.description'),
      conditions: ['teacher'],
      buttons: [
        {
          name: translate('course.actions.add-first-session'),
          to: '',
          conditions: ['query', 'teacher'],
        },
      ],
    };
}
